import * as React from "react";
const IconBd = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 85.333 513 342"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path  d="M0 85.331h513v342H0z" />
    <circle cx={218.902} cy={256.5} r={115}  />
  </svg>
);
export default IconBd;
